<template>
  <div>
    <child-development-class-container />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

// import PageTitle from '@/components/atoms/PageTitle.vue';
import ChildDevelopmentClassContainer from "@/containers/child-development/ChildDevelopmentClassContainer.vue";

export default defineComponent({
  components: {
    ChildDevelopmentClassContainer,
  },
});
</script>
